import api from '@/api/api';
import router from '@/router';
import { Icon, Dialog, Toast } from 'vant';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    [Icon.name]: Icon,
  }
})
export default class MyInfo extends Vue {

  openId = '';
  isPool: any = '0'; // 人才库进入（1）或招聘进入（0）
  resumeInfo: any = null; // 简历信息
  exameCount = 0; // 考试测评数量
  interviewCount = 0; // 面试通知数量
  isShowEntryConfirm = false; // 是否展示入职确认按钮
  offerId = ''; // 入职确认ID

  /**
   * 1.微信公众号首先跳转到该页面
   * 2.首先获取openid，获取后存入缓存中
   * 3.获取openid后，检验是否绑定过手机号，若未绑定，则先跳转到绑定手机号页面
   * 4.判断是【招聘管理】还是【人才库】，分别调用对应的接口，获取对应的信息
   */

  created() {
    this.isPool = sessionStorage.getItem('isPool');
    const wechatUser = JSON.parse(sessionStorage.getItem('wechatUser')||'{}');
    this.openId = wechatUser.openid;
  }

  mounted() {
    if (this.isPool === '0') { // 招聘进入
      this.queryRecruitMainResume();
      this.queryRecruitExams();
      this.queryRecruitInterviews();
      this.queryRecruitOfferConfirms();
    } else if (this.isPool === '1'){ // 人才库进入
      this.queryTalentpoolMainResume();
    }
  }

  // 查询人才库主简历
  queryTalentpoolMainResume() {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
      duration: 0,
    });
    api.queryTalentpoolMainResume({ openId: this.openId }).then(
      (res: any) => {
        Toast.clear();
        if (res.resumeInfo) {
          this.resumeInfo = res.resumeInfo;
        } else {
          router.push('/fill-resume');
        }
      }
    ).catch((error: any) => {
      Toast.clear();
      Dialog.alert({
        title: '提示',
        message: error,
      });
    })
  }


  // 查询招聘主简历
  queryRecruitMainResume() {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
      duration: 0,
    });
    api.queryRecruitMainResume({ openId: this.openId }).then(
      (res: any) => {
        Toast.clear();
        if (res.resumeInfo) {
          this.resumeInfo = res.resumeInfo;
        } else {
          router.push('/fill-resume');
        }
      }
    ).catch((error: any) => {
      Toast.clear();
      Dialog.alert({
        title: '提示',
        message: error,
      });
    })
  }

  // 获取考试测评数量
  queryRecruitExams() {
    api.queryRecruitExams({ openId: this.openId }).then(
      (res: any) => {
        this.exameCount = res.evaluateScoreInfos.length;
      }
    ).catch((error: any) => {
      Dialog.alert({
        title: '提示',
        message: error,
      });
    })
  }

  // 获取面试通知数量
  queryRecruitInterviews() {
    api.queryRecruitInterviews({ openId: this.openId }).then(
      (res: any) => {
        this.interviewCount = res.interviews.length;
      }
    ).catch((error: any) => {
      Dialog.alert({
        title: '提示',
        message: error,
      });
    })
  }

  // 判断是否有入职确认id
  queryRecruitOfferConfirms() {
    api.queryRecruitOfferConfirms({ openId: this.openId }).then(
      (res: any) => {
        this.offerId = res.id;
        this.isShowEntryConfirm = res.id ? true : false;
      }
    ).catch((error: any) => {
      Dialog.alert({
        title: '提示',
        message: error,
      });
    })
  }

  openDetail() {
    router.push(`/resume-detail?resumeId=${this.resumeInfo.id}`)
  }

  // 进入我的简历
  toResume() {
    router.push(`/resume-list`);
  }

  // 进入问卷调研
  toQuestionnaire() {
    router.push('/interview-evaluation');
  }

  // 进入入职确认
  entryConfirm() {
    router.push(`/confirm-mobile?offerId=${this.offerId}`);
  }

  // 进入考试测评
  toExame() {
    router.push('/exam-evaluation');
  }

  // 进入面试通知
  toInterview() {
    router.push('/interview-notice');
  }
}